<template>
  <el-empty :description="description" :image="empty" :image-size="size" />
</template>

<script>
import empty from "@/assets/images/empty.png";

export default {
  name: "zxsb-dialog",
  props: {
    description: {
      type: String,
      default: "暂无数据",
    },
    size: {
      type: Number,
      default: 0,
    },
    empty: {
      type: String,
      default: empty,
    },
  },
  data() {
    return {
      // empty,
    };
  },
  /* watch: {
    showDialog() {
      this.visible = this.showDialog;
    },
  },*/
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.el-empty {
  height: 100%;
  padding: 20px;

  /deep/ .el-empty__image {
    max-height: calc(100% - 41px);
    width: auto;
  }

  /deep/.el-empty__description > p {
    line-height: 21px;
  }
}
</style>
